import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';

type DialogData = {
  fees: {
    amount: number;
    currency: string;
  }[];
};

@Component({
  selector: 'app-start-with-credit-dialog',
  templateUrl: './start-with-credit-dialog.component.html',
  styleUrls: ['./start-with-credit-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class StartWithCreditDialogComponent implements OnInit {
  private workflowService = inject(WorkflowService);
  private dialogRef =
    inject<
      MatDialogRef<StartWithCreditDialogComponent, RunTransition | undefined>
    >(MatDialogRef);
  data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private translate = inject(TranslateService);

  dataLoading = false;
  loading = false;
  dialogData?: DialogData;

  fees: string = '?';

  async ngOnInit(): Promise<void> {
    try {
      this.dataLoading = true;

      this.dialogData = await this.workflowService.getDialogData<DialogData>(
        this.data,
      );

      this.fees = this.dialogData.fees
        .map((f) => {
          const amount = new Intl.NumberFormat(this.translate.currentLang, {
            style: 'currency',
            currency: f.currency,
            maximumFractionDigits: 0,
          }).format(f.amount);

          return amount;
        })
        .join(' | ');

      this.dataLoading = false;
    } catch (error) {
      this.workflowService.showTransitionError(error);
      this.dialogRef.close();
    }
  }

  async submit(): Promise<void> {
    const closeValue: RunTransition = {
      ...(this.data.extraParams ?? {}),
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  }
}
